/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Alpha_NoteInputs */

const en_pc_dl_alpha_note = /** @type {(inputs: Pc_Dl_Alpha_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft is alpha software. Keep a backup of important documents, even though every save is incremental and never rewrites your original bytes.`)
};

const zh_pc_dl_alpha_note = /** @type {(inputs: Pc_Dl_Alpha_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 目前处于 alpha 阶段。尽管每次保存都是增量的、不会改写原始字节，重要文档仍请保留备份。`)
};

/**
* | output |
* | --- |
* | "PdfCraft is alpha software. Keep a backup of important documents, even though every save is incremental and never rewrites your original bytes." |
*
* @param {Pc_Dl_Alpha_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_alpha_note = /** @type {((inputs?: Pc_Dl_Alpha_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Alpha_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_alpha_note(inputs)
	return zh_pc_dl_alpha_note(inputs)
});
export { pc_dl_alpha_note as "pc.dl.alpha_note" }